import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderTypeGroup } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useImport = () => {
  const { locale } = useLocale();
  const { mutate: importStakeholders, isPending } = useAppMutation(
    [QueryKey.STAKEHOLDERS_BULK_IMPORT],
    {
      mutationFn: ({
        companyId,
        typeGroup,
        file,
      }: {
        companyId: string;
        file: File;
        typeGroup: StakeholderTypeGroup;
      }) => {
        return ApiService.uploadFile().callback(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', typeGroup, 'import'],
          },
          ['file', file],
          { locale },
        );
      },
    },
  );
  return { importStakeholders, isPending };
};
